import { Checkbox as FCheckbox, ICheckboxProps as FICheckboxProps, ICheckboxStyles } from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { combineClassNames } from '../../utils/utils';
import { checkboxStylesDefault } from './Checkbox.styles';

export interface ICheckboxProps extends Omit<FICheckboxProps, 'styles'>, IComponent<ICheckboxStyles> {
  hasError?: boolean;
}

export const Checkbox = forwardRef((props: ICheckboxProps, ref: Ref<HTMLDivElement>) => {
  const { styles, hasError, className, ..._fProps } = props;
  const fProps: FICheckboxProps = {
    ..._fProps,
    styles: useThemeStyles<Partial<ICheckboxStyles>>(checkboxStylesDefault, styles),
    className: combineClassNames(className, hasError && 'has-error'),
  };
  return <FCheckbox {...fProps} ref={ref} data-test={props['data-test'] || 'checkbox'} />;
});
